import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';

import {InvalidVoucherRoutingModule} from './invalid-voucher-routing.module';
import {InvalidVoucherComponent} from './invalid-voucher.component';

@NgModule({
  imports: [
    CommonModule,
    InvalidVoucherRoutingModule,
  ],
  declarations: [
    InvalidVoucherComponent,
  ],
})
export class InvalidVoucherModule { }
